<template>
   <div class="container">
    <div class="row">
      <h1><span class="glyphicon glyphicon-user"></span> {{ loggedUser.get('name') }}</h1>
      <hr>
      <div v-if="loading">
        <loader></loader>
      </div>
      <div v-else>

        <router-link id="btn-add-request" :to="{name: 'RequestOpen'}" type="button" class="btn btn-primary">
          <span class="glyphicon glyphicon-plus"></span> Abrir Requisição
        </router-link>

        <ul class="nav nav-tabs">
          <li role="presentation" :class="{active: (tabs.active == 'mine')}" @click="changeTab('mine')" class="tab">
            <a>Minhas Requisições <span class="badge">{{userRequestsCount}}</span></a>
          </li>
          <li role="presentation" :class="{active: (tabs.active == 'linked')}"  @click="changeTab('linked')" class="tab">
            <a id="linked-requests-panel-link">Requisições Vinculadas em Aberto <span class="badge badge-notifications">{{linkedRequestsCount}}</span></a>
          </li>
          <li role="presentation" :class="{active: (tabs.active == 'invites')}"  @click="changeTab('invites')" class="tab">
            <a id="linked-requests-panel-link">Convites de Requisições <span class="badge badge-notifications">{{invitedRequestsCount}}</span></a>
          </li>
          <li role="presentation" :class="{active: (tabs.active == 'workflows')}"  @click="changeTab('workflows')" class="tab">
            <a id="workflows-panel-link">Fluxos que sou responsável <span class="badge badge-notifications">{{reponsibleWorkflowsCount}}</span></a>
          </li>
        </ul>

        <div v-if="tabs.active == 'mine'" class="tab-content">
          <div class="row">
            <div class="col-sm-2">
              <select class="input-sm" v-model="userRequestsPerPage" @change="getUserRequests">
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="15">15</option>
              </select>
            </div>
            <div class="col-sm-5"></div>
            <div class="col-sm-5">
              <b-form-input v-model="userRequestsFilter" @keyup.enter="getUserRequests" placeholder="Digite e pressione Enter" class="input-sm"></b-form-input>
            </div>
          </div>
            <b-table id="user-requests" 
              :items="userRequests" 
              :fields="userRequestsfields"
              striped hover show-empty>
              <span slot="icon" slot-scope="item" class="glyphicon glyphicon-file"> </span>
              <span slot="reqType" slot-scope="item"> {{item.value.get('name')}}</span>
              <span slot="workflow" slot-scope="item">
                  {{item.value.get('name')}}
              </span>
              <request-status slot="status" slot-scope="item" :status="item.value"></request-status>
              <span slot="options" slot-scope="item">
                <router-link :to="{name: 'RequestDetail', params: {id: item.item.objectId}}" 
                  v-if="item.item.workflow.get('feedback')"
                  class="btn btn-primary btn-xs">
                  <span class="glyphicon glyphicon-search" title="Ver Requisição"></span> Ver/Editar
                </router-link>
                <router-link :to="{name: 'RequestConfirmation', params: {requestId: item.item.objectId}}"
                    class="btn btn-primary btn-xs">
                  <span class="glyphicon glyphicon-ok" title="Ver Confirmação"></span> Confirmação
                </router-link>
              </span>
              <span slot="empty">
                
              </span>
            </b-table>
            <b-pagination size="sm" 
              :total-rows="userRequestsCount" 
              :per-page="userRequestsPerPage" 
              @input="getUserRequests"
              v-model="userRequestsCurrentPage"/>
        </div>

        <div v-if="tabs.active == 'linked'" class="tab-content">
          <div class="row">
            <div class="col-sm-2">
              <select class="input-sm" v-model="linkedRequestsPerPage" @change="getLinkedRequests">
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="15">15</option>
              </select>
            </div>
            <div class="col-sm-5"></div>
            <div class="col-sm-5">
              <b-form-input v-model="linkedRequestsFilter" @keyup.enter="getLinkedRequests" placeholder="Digite e pressione Enter" class="input-sm"></b-form-input>
            </div>
          </div>
          <b-table id="linked-requests" 
            :items="linkedRequests" 
            :fields="linkedRequestsfields" 
            striped hover>
            <span slot="icon" slot-scope="item">
                <span class="glyphicon glyphicon-file"> </span>
            </span>
            <span slot="reqType" slot-scope="item">
                <span v-if="item.value">{{item.value.get('name')}}</span>
            </span>
            <span slot="workflow" slot-scope="item">
                <span v-if="item.value">{{item.value.get('name')}}</span>
            </span>
            <request-status slot="status" slot-scope="item" :status="item.value"></request-status>
            <span slot="owner" slot-scope="item">
                <span v-if="item.value">{{item.value.get('name')}}</span>
            </span>
            <router-link slot="options" slot-scope="item"
                          :to="{name: 'RequestDetail', params: {id: item.item.objectId}}" class="btn btn-primary btn-xs">
              <span class="glyphicon glyphicon-search"></span> Ver
            </router-link>
          </b-table>
          <b-pagination size="sm" 
            :total-rows="linkedRequestsCount" 
            :per-page="linkedRequestsPerPage" 
            @input="getLinkedRequests"
            v-model="linkedRequestsCurrentPage"/>
        </div>

        <div v-if="tabs.active == 'invites'" class="tab-content">
          <div class="row">
            <div class="col-sm-2">
              <select class="input-sm" v-model="invitedRequestsPerPage" @change="getInvitedRequests">
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="15">15</option>
              </select>
            </div>
            <div class="col-sm-5"></div>
            <div class="col-sm-5">
              <b-form-input v-model="invitedRequestsFilter" @keyup.enter="getInvitedRequests" placeholder="Digite e pressione Enter" class="input-sm"></b-form-input>
            </div>
          </div>
          <b-table id="linked-requests" 
            :items="invitedRequests" 
            :fields="invitedRequestsfields" 
            striped hover>
            <span slot="icon" slot-scope="item">
                <span class="glyphicon glyphicon-file"> </span>
            </span>
            <span slot="reqType" slot-scope="item">
                <span v-if="item.value">{{item.value.get('name')}}</span>
            </span>
            <span slot="workflow" slot-scope="item">
                <span v-if="item.value">{{item.value.get('name')}}</span>
            </span>
            <request-status slot="status" slot-scope="item" :status="item.value">
            </request-status>
            <router-link slot="options" slot-scope="item"
                         :to="{name: 'RequestDetail', params: {id: item.item.objectId}}"
                         class="btn btn-primary btn-xs">
              <span class="glyphicon glyphicon-search"></span> Ver
            </router-link>
          </b-table>
          <b-pagination size="sm" 
            :total-rows="invitedRequestsCount" 
            :per-page="invitedRequestsPerPage" 
            @input="getInvitedRequests"
            v-model="invitedRequestsCurrentPage"/>
        </div>

        <div v-if="tabs.active == 'workflows'" class="tab-content">
          <div class="row">
            <div class="col-sm-2">
              <select class="input-sm" v-model="reponsibleWorkflowsPerPage" @change="getResponsibleWorkflows">
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="15">15</option>
              </select>
            </div>
            <div class="col-sm-5"></div>
            <div class="col-sm-5">
              <b-form-input 
                v-model="reponsibleWorkflowsFilter" 
                @keyup.enter="getResponsibleWorkflows" 
                placeholder="Digite e pressione Enter" class="input-sm"></b-form-input>
            </div>
          </div>
          <b-table id="workflows-table" 
            :items="reponsibleWorkflows" 
            :fields="reponsibleWorkflowsFields" striped hover>
            <span slot="icon" slot-scope="item">
                <span class="glyphicon glyphicon-log-out"> </span>
            </span>
            <span slot="reqType" slot-scope="item">
                <span v-if="item.value">{{item.value.get('name')}}</span>
            </span>
            <span slot="name" slot-scope="item">
                <span v-if="item.value">{{item.value}}</span>
            </span>
            <router-link slot="options" slot-scope="item"
                          :to="{name: 'WorkflowRequests', params: {id: item.item.objectId}}"
                          class="btn btn-primary btn-xs">
              <span class="glyphicon glyphicon-search"></span> Ver
            </router-link>
          </b-table>
          <b-pagination size="sm" 
            :total-rows="reponsibleWorkflowsCount" 
            :per-page="reponsibleWorkflowsPerPage" 
            @input="getResponsibleWorkflows"
            v-model="reponsibleWorkflowsCurrentPage"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import {
    Parse
  } from '../Global'
  import RequestStatus from './util/RequestStatus'
  import Loader from './util/Loader'
  import { handleParseError } from './util/ErrorHandling'

  export default {
    components: {
      Loader,
      RequestStatus
    },
    mounted () {
      this.getRequests()
      if (this.$route.query.tb) {
        this.tabs.active = this.$route.query.tb
      }
    },
    data () {
      return {
        loading: false,
        loggedUser: Parse.User.current(),
        userRequests: [],
        userRequestsCount: 0,
        userRequestsCurrentPage: 1,
        userRequestsPerPage: 10,
        userRequestsFilter: '',
        userRequestsfields: {
          icon: { label: '' },
          objectId: { label: 'Identificador' },
          reqType: { label: 'Tipo', sortable: true },
          workflow: { label: 'Workflow', sortable: true },
          status: { label: 'Status', sortable: true },
          createdAtFmt: {label: 'Data de Abertura', sortable: true},
          options: {label: 'Opções'}
        },
        linkedRequests: [],
        linkedRequestsCount: 0,
        linkedRequestsCurrentPage: 1,
        linkedRequestsPerPage: 10,
        linkedRequestsFilter: '',
        linkedRequestsfields: {
          icon: { label: '' },
          objectId: { label: 'Identificador' },
          reqType: { label: 'Tipo', sortable: true },
          workflow: { label: 'Workflow', sortable: true },
          status: { label: 'Status', sortable: true },
          owner: { label: 'Criador', sortable: true },
          createdAtFmt: {label: 'Data de Abertura', sortable: true},
          options: {label: 'Opções'}
        },
        invitedRequests: [],
        invitedRequestsCount: 0,
        invitedRequestsCurrentPage: 1,
        invitedRequestsPerPage: 10,
        invitedRequestsFilter: '',
        invitedRequestsfields: {
          icon: { label: '' },
          objectId: { label: 'Identificador' },
          reqType: { label: 'Tipo', sortable: true },
          workflow: { label: 'Workflow', sortable: true },
          status: { label: 'Status', sortable: true },
          createdAtFmt: {label: 'Data de Abertura', sortable: true},
          options: {label: 'Opções'}
        },
        reponsibleWorkflows: [],
        reponsibleWorkflowsCount: 0,
        reponsibleWorkflowsCurrentPage: 1,
        reponsibleWorkflowsPerPage: 10,
        reponsibleWorkflowsFilter: '',
        reponsibleWorkflowsFields: {
          icon: { label: '' },
          objectId: { label: 'Identificador' },
          reqType: { label: 'Tipo', sortable: true },
          name: { label: 'Nome', sortable: true },
          options: {label: 'Opções'}
        },
        tabs: {
          active: 'mine'
        }
      }
    },
    methods: {
      getRequests () {
        let self = this
        self.loading = true
        self.getUserRequests().then(data => {
          return self.getLinkedRequests()
        }).then(data => {
          return self.getInvitedRequests()
        }).then(data => {
          return self.getResponsibleWorkflows()
        }).then(() => {
          self.loading = false
        }).fail(error => {
          self.loading = false
          handleParseError(self, error)
        })
      },
      getUserRequests () {
        let self = this
        self.loading = true
        let params = {
          currentPage: self.userRequestsCurrentPage,
          perPage: self.userRequestsPerPage,
          filter: self.userRequestsFilter
        }
        return Parse.Cloud.run('listUserRequests', params).then(data => {
          self.userRequestsCount = data.total
          self.userRequests = data.requests
          self.loading = false
        })
      },
      getLinkedRequests () {
        let self = this
        self.loading = true
        let params = {
          currentPage: self.linkedRequestsCurrentPage,
          perPage: self.linkedRequestsPerPage,
          filter: self.linkedRequestsFilter
        }
        return Parse.Cloud.run('listLinkedRequests', params).then(data => {
          self.linkedRequestsCount = data.total
          self.linkedRequests = data.requests
          self.loading = false
        })
      },
      getInvitedRequests () {
        let self = this
        self.loading = true
        let params = {
          currentPage: self.invitedRequestsCurrentPage,
          perPage: self.invitedRequestsPerPage,
          filter: self.invitedRequestsFilter
        }
        return Parse.Cloud.run('listInvitedRequests', params).then(data => {
          self.invitedRequestsCount = data.total
          self.invitedRequests = data.requests
          self.loading = false
        })
      },
      getResponsibleWorkflows () {
        let self = this
        self.loading = true
        let params = {
          currentPage: self.reponsibleWorkflowsCurrentPage,
          perPage: self.reponsibleWorkflowsPerPage,
          filter: self.reponsibleWorkflowsFilter
        }
        return Parse.Cloud.run('listResponsibleWorkflows', params).then(data => {
          self.reponsibleWorkflowsCount = data.total
          self.reponsibleWorkflows = data.workflows
          self.loading = false
        })
      },
      changeTab (tab) {
        this.tabs.active = tab
      }
    }
  }

</script>

<style scoped>
.badge-notifications {
  background-color: lighten(green, 10%) !important;
}
.tab {
  cursor: pointer;
}
.tab-content {
  padding: 20px;
  border-style: solid;
  border-color: #ddd;
  border-width: 0px 1px 1px 1px;
}
.grant {
  color: green
}
.deny {
  color: red
}
.processing {
  color: blue
}
#btn-add-request {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// UserProfile.vue?ad5a49a6